import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  margin-bottom: 2rem;

  > div{
    flex: 1;
    margin: 0;
    
    &:last-child{
      margin-left: 2rem;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;

  > div {
    flex: 1;
  }
`;

export const Subtitle = styled.h3`
  margin: 1.5rem 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
`;

export const SideContainer = styled.div`
  &+div{
    margin-left: 2rem;
  }
`; 